import { FilePdfOutlined, FolderOpenOutlined } from "@ant-design/icons";
import { Collapse } from "antd";
import React from "react";
import "./InvestorInformation.css";

const AnnualReturns = () => {
  const { Panel } = Collapse;

  const annualReturnsData = [
    {
      year: "2024-25",
      documents: [
        {
          name: "Annual Returns 2024-25",
          file: "/pdfs/annualReturns/Annual Return 2024-25.pdf",
        },
      ],
    },
    {
      year: "2023-24",
      documents: [
        {
          name: "Annual Returns 2023-24",
          file: "/pdfs/annualReturns/Annual Return 2023-24.pdf",
        },
      ],
    },
    {
      year: "2022-23",
      documents: [
        {
          name: "Annual Returns 2022-23",
          file: "/pdfs/annualReturns/Annual Return 2022-23.pdf",
        },
      ],
    },
  ];

  return (
    <Collapse accordion bordered={false} className="policy-collapse" style={{ marginBottom: "30px" }}>
      {annualReturnsData.map((item, index) => (
        <Panel
          key={index}
          header={
            <div className="folder-header">
              <FolderOpenOutlined />
              <span>{item.year}</span>
            </div>
          }
          className="policy-panel"
        >
          <ul className="policy-doc-list">
            {item.documents?.map((doc, i) => (
              <li key={i} className="policy-doc-item">
                <a
                  href={doc.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="policy-doc-link"
                >
                  <FilePdfOutlined
                    style={{ color: "#d32029", marginRight: "8px" }}
                  />
                  {doc.name}
                </a>
              </li>
            ))}
          </ul>
        </Panel>
      ))}
    </Collapse>
  );
};

export default AnnualReturns;